import React from 'react'
import {
  CallIcon,
  CutleryIcon,
  DeliveryAndPaymentIcon,
  DocumentIcon,
  GalleryIcon,
  InfoIcon,
  LocationIcon,
  NewsIcon,
  PercentIcon,
  VacanciesIcon,
} from '@/_assets/icon-components'
import { LuStar } from 'react-icons/lu'

export const getPage = (
  key: string
): {
  title: string
  icon: React.ReactElement
  route: string
  protected?: boolean
  type?: string
} => {
  switch (key) {
    case 'branches':
      return {
        title: 'branches',
        icon: <LocationIcon color='#ED3237' />,
        route: '/branches',
      }
    case 'contacts':
      return {
        title: 'contacts',
        icon: <CallIcon color='#ED3237' />,
        route: '/contacts',
      }
    case 'delivery_and_payment':
      return {
        title: 'delivery_and_payment',
        icon: <DeliveryAndPaymentIcon color='#ED3237' />,
        route: '/delivery',
      }
    case 'about_us':
      return {
        title: 'about',
        icon: <InfoIcon color='#ED3237' />,
        route: '/about',
      }
    case 'reservations':
      return {
        title: 'reservations',
        icon: <InfoIcon color='#ED3237' />,
        route: '/reservations',
        protected: true,
      }
    case 'vacancies':
      return {
        title: 'vacancies',
        icon: <VacanciesIcon color='#ED3237' />,
        route: '/vacancies',
      }
    case 'recipes':
      return {
        title: 'recipes',
        icon: <CutleryIcon color='#ED3237' />,
        route: '/recipes',
      }
    case 'sale':
      return {
        title: 'sale',
        icon: <PercentIcon color='#ED3237' />,
        route: '/sale',
      }
    case 'news':
      return {
        title: 'news',
        icon: <NewsIcon color='#ED3237' />,
        route: '/news',
      }
    case 'events':
      return {
        title: 'gallery',
        icon: <GalleryIcon color='#ED3237' />,
        route: '/gallery',
      }
    case 'reviews':
      return {
        title: 'leave_feedback',
        icon: <LuStar color='#ED3237' />,
        route: '/reviews',
        protected: true,
      }
    default:
      return {
        title: key,
        icon: <DocumentIcon color='#ED3237' />,
        route: '/pages/' + key,
        type: 'dynamic',
      }
  }
}
